/**
 * Normalizes an array of tags by trimming whitespace, filtering out empty values, and removing duplicates
 */
export const normalizeTags = (tags: string[]) => Array.from(new Set(tags.map(tag => tag.trim()).filter(Boolean)));
